import React, { useState, useEffect } from "react";
import axios from "axios";
import Badge from "react-bootstrap/Badge";
import { FaUser, FaArrowLeft, FaIdCard } from "react-icons/fa";
import { BsGenderAmbiguous } from "react-icons/bs";
import { BiCake } from "react-icons/bi";
import { MdFamilyRestroom, MdContacts, MdPhone, MdHome } from "react-icons/md";

import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";

import AuthContext from "../../../components/shared/Context";

const getStatusBadgeClass = (status) => {
  switch (status) {
    case "REGISTRATION":
      return "bg-success text-white";
    case "RECORD_UPDATE":
      return "bg-warning text-dark";
    case "TREATMENT_CENTER_CHANGE":
      return "bg-danger text-white";
    default:
      return "bg-primary text-white";
  }
};

const PatientTimelineChild = ({ pRecord }) => {
  //Error Logging Service
  const [{ errorLogApi, customEncrypt, decryptData, maskAadhaarString }] =
    useAtom(gbState);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    let urlLink = `${process.env.REACT_APP_API_URL}/patienttimeline/${pRecord?._id}`;
    const config = {
      headers: { Authorization: `Bearer ${localStorage?.getItem("token")}` },
    };
    axios
      .get(urlLink, config)
      .then((res) => {
        const oldData = res?.data;

        //console.log(updatedData);
        setData(oldData);
      })
      .catch((err) => {
        errorLogApi(err, "PatientListChild", urlLink);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 3000); // 3 seconds delay
      });
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case "REGISTRATION":
        return "#28a745"; // green
      case "RECORD_UPDATE":
        return "#fd7e14"; // orange
      case "TREATMENT_CENTER_CHANGE":
        return "#dc3545"; // red
      default:
        return "#007bff"; // blue
    }
  };

  return (
    <div>
      <div
        style={{
          padding: "20px",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          marginBottom: "20px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        {/* Header with back button */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <FaUser style={{ color: "#007bff" }} />
            <h4 style={{ margin: 0 }}>Patient Timeline</h4>
          </div>
          <button
            onClick={() => window.history.back()}
            style={{
              padding: "8px 15px",
              border: "none",
              borderRadius: "4px",
              backgroundColor: "#007bff",
              color: "white",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <FaArrowLeft fontSize="small" />
            Back
          </button>
        </div>

        {/* Patient basic info */}
        <div style={{ marginBottom: "20px" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "20px",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            {/* Patient Basic Info Section */}
            <div style={{ padding: "15px" }}>
              <h5
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  borderBottom: "2px solid #f0f0f0",
                  paddingBottom: "10px",
                  marginBottom: "15px",
                }}
              >
                <FaIdCard style={{ color: "#666" }} />
                {pRecord.patient_name}
              </h5>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <FaIdCard fontSize="small" style={{ color: "#666" }} />
                  <strong>Patient ID:</strong> {pRecord.patientId}
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <BsGenderAmbiguous
                    fontSize="small"
                    style={{ color: "#666" }}
                  />
                  <strong>Gender:</strong> {JSON.parse(pRecord.gender).label}
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <BiCake fontSize="small" style={{ color: "#666" }} />
                  <strong>DOB:</strong>{" "}
                  {new Date(pRecord.date_of_birth).toLocaleDateString()}
                </div>
              </div>
            </div>

            {/* Parent Info Section */}
            <div style={{ padding: "15px" }}>
              <h6
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  borderBottom: "2px solid #f0f0f0",
                  paddingBottom: "10px",
                  marginBottom: "15px",
                }}
              >
                <MdFamilyRestroom style={{ color: "#666" }} />
                Parent Information
              </h6>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <FaUser fontSize="small" style={{ color: "#666" }} />
                  <strong>Father's Name:</strong> {pRecord.fathers_name}
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <FaUser fontSize="small" style={{ color: "#666" }} />
                  <strong>Mother's Name:</strong> {pRecord.mothers_name}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="timeline-container"
        style={{ maxWidth: "800px", margin: "20px auto", padding: "20px" }}
      >
        {data.map((item, index) => (
          <div
            key={item._id}
            className="timeline-item"
            style={{
              position: "relative",
              padding: "20px",
              borderLeft: "2px solid #e0e0e0",
              marginLeft: "20px",
              marginBottom: "0px",
            }}
          >
            {/* Timeline dot */}
            <div
              style={{
                position: "absolute",
                left: "-11px",
                top: "24px",
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                backgroundColor: getStatusColor(item.status),
              }}
            />

            {/* Status Badge */}
            <div style={{ marginBottom: "10px" }}>
              <Badge className={getStatusBadgeClass(item.status)}>
                {item.status}
              </Badge>
            </div>

            {/* Timestamp */}
            <small
              style={{ color: "#666", display: "block", marginBottom: "10px" }}
            >
              {new Date(item.timestamp).toLocaleString()}
            </small>

            {/* Description */}
            <div style={{ marginBottom: "10px" }}>{item.description}</div>

            {/* Treatment Center Details */}
            {item.treatmentCenter && (
              <div
                style={{
                  backgroundColor: "#f8f9fa",
                  padding: "15px",
                  borderRadius: "8px",
                  marginTop: "10px",
                }}
              >
                <h6 style={{ marginBottom: "10px" }}>Treatment Center</h6>
                <div>{item.treatmentCenter.tcenters.name_tc}</div>
                <small>{item.treatmentCenter.tcenters.institution}</small>
              </div>
            )}

            {/* Diagnosis Details */}
            {item.diagnoses && (
              <div
                style={{
                  backgroundColor: "#ffebeb",
                  padding: "15px",
                  borderRadius: "8px",
                  marginTop: "10px",
                }}
              >
                <h6 style={{ marginBottom: "10px" }}>Diagnosis</h6>
                <div>{item.diagnoses.diagnosis_name}</div>
                {item.diagnoses.severity_of_illness && (
                  <small>
                    Severity:{" "}
                    {JSON.parse(item.diagnoses.severity_of_illness).label}
                  </small>
                )}
              </div>
            )}

            {/* Notes */}
            {item.notes && (
              <div
                style={{
                  marginTop: "10px",
                  fontStyle: "italic",
                  color: "#666",
                }}
              >
                Note: {item.notes}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PatientTimelineChild;
